module.exports = __webpack_public_path__ + "static/media/login (1).f1dc9d22.svg";